(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-featured-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('slider-component[data-autoplay="true"]').forEach((slider) => {
    const speed = parseInt(slider.dataset.speed) || 6000;
    const nextBtn = slider.querySelector('.slider-button--next');
    if (!nextBtn) return;

    let autoplay = setInterval(() => {
      nextBtn.click();
    }, speed);

    // Pause autoplay on hover (optional)
    slider.addEventListener('mouseenter', () => clearInterval(autoplay));
    slider.addEventListener('mouseleave', () => {
      autoplay = setInterval(() => nextBtn.click(), speed);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-grid-view"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){
  const playBtn = e.target.closest('.cg-play');
  const muteBtn = e.target.closest('.cg-mute');
  if(!playBtn && !muteBtn) return;

  const wrapper = e.target.closest('.cg-video-wrapper');
  const video = wrapper.querySelector('video');
  if(!video) return;

  e.preventDefault();

  if(playBtn){
    if(video.paused){
      video.play();
      wrapper.classList.add('is-playing');
      playBtn.textContent = "⏸"; // Pause symbol
    } else {
      video.pause();
      wrapper.classList.remove('is-playing');
      playBtn.textContent = "▶"; // Play symbol
    }
  }

  if(muteBtn){
    video.muted = !video.muted;
    wrapper.classList.toggle('is-muted', video.muted);
    muteBtn.textContent = video.muted ? "🔇" : "🔊"; // Mute / Unmute
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content_with_collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('slider-component[data-autoplay="true"]').forEach((slider) => {
    const speed = parseInt(slider.dataset.speed) || 6000;
    const nextBtn = slider.querySelector('.slider-button--next');
    if (!nextBtn) return;

    let autoplay = setInterval(() => {
      nextBtn.click();
    }, speed);

    // Pause autoplay on hover (optional)
    slider.addEventListener('mouseenter', () => clearInterval(autoplay));
    slider.addEventListener('mouseleave', () => {
      autoplay = setInterval(() => nextBtn.click(), speed);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('slider-component[data-autoplay="true"]').forEach((slider) => {
    const speed = parseInt(slider.dataset.speed) || 6000;
    const nextBtn = slider.querySelector('.slider-button--next');
    if (!nextBtn) return;

    let autoplay = setInterval(() => {
      nextBtn.click();
    }, speed);

    // Pause autoplay on hover (optional)
    slider.addEventListener('mouseenter', () => clearInterval(autoplay));
    slider.addEventListener('mouseleave', () => {
      autoplay = setInterval(() => nextBtn.click(), speed);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ky-half-banner-featured-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('slider-component[data-autoplay="true"]').forEach((slider) => {
    const speed = parseInt(slider.dataset.speed) || 6000;
    const nextBtn = slider.querySelector('.slider-button--next');
    if (!nextBtn) return;

    let autoplay = setInterval(() => {
      nextBtn.click();
    }, speed);

    // Pause autoplay on hover (optional)
    slider.addEventListener('mouseenter', () => clearInterval(autoplay));
    slider.addEventListener('mouseleave', () => {
      autoplay = setInterval(() => nextBtn.click(), speed);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lc-multi-navigation-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

  const tabButtons = document.querySelectorAll('.tabs button');
  const tabContents = document.querySelectorAll('.tab-content');

  function initSlider(slider) {
    if (!slider) return;

    // Call slider library update if available
    if (typeof slider.update === 'function') slider.update();

    // Setup autoplay
    if (slider.dataset.autoplay === 'true') {
      const speed = parseInt(slider.dataset.speed) || 6000;
      const nextBtn = slider.querySelector('.slider-button--next');
      if (!nextBtn) return;

      clearInterval(slider.autoplay);
      slider.autoplay = setInterval(() => nextBtn.click(), speed);

      slider.addEventListener('mouseenter', () => clearInterval(slider.autoplay));
      slider.addEventListener('mouseleave', () => {
        slider.autoplay = setInterval(() => nextBtn.click(), speed);
      });
    }
  }

  // Initialize sliders in active tabs on page load
  document.querySelectorAll('.tab-content.active slider-component').forEach(slider => {
    initSlider(slider);
  });

  // Switch tabs
  tabButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      const tabId = this.dataset.tabId;

      // Remove active classes
      tabButtons.forEach(b => b.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));

      // Add active to clicked tab
      this.classList.add('active');
      const activeTab = document.getElementById(tabId);
      activeTab.classList.add('active');

      // Re-initialize slider in active tab
      const slider = activeTab.querySelector('slider-component');
      initSlider(slider);
    });
  });


  function initQuickAddForSection(sectionId) {
    const section = document.getElementById(`collection-${sectionId}`);
    if (!section) return;

    section.querySelectorAll('.card-wrapper-box').forEach(quickCartContainer => {
      if (quickCartContainer.dataset.qatcInit === 'true') return;
      quickCartContainer.dataset.qatcInit = 'true';

      const quickAddBtn = quickCartContainer.querySelector('.ethnc-qatc-btn-container');
      const atcForm = quickCartContainer.querySelector('.bt-qatc-form');
      const mediaContainer = quickCartContainer.querySelector('.ethnc-form-media');
      if (!quickAddBtn || !atcForm) return;

      quickAddBtn.addEventListener('click', () => {
        const onlyChildInput = quickCartContainer.querySelector('.bt-qatc-form-variant-input[data-only-child]');
        if (onlyChildInput) {
          fetch(`${routes.cart_url}.json`)
            .then(res => res.json())
            .then(cartData => {
              const totalCartPrice = cartData.total_price / 100;
              const selectedPrice = parseFloat(onlyChildInput.dataset.price) / 100;

              if (totalCartPrice + selectedPrice > 250000) {
                window.showAlert('You cannot exceed PKR 250,000');
                return;
              }

              const itemInCart = cartData.items.find(item => item.variant_id === parseFloat(onlyChildInput.value));
              if (itemInCart && itemInCart.quantity >= 3) {
                window.showAlert('Max 3 items per size allowed');
                return;
              }

              atcFormApi(atcForm);
              atcForm.reset();
            });
        } else {
          quickCartContainer.querySelector('.bt-qatc-container')?.classList.add('is-visible');
          quickCartContainer.querySelector('.bt-qatc-form-container')?.classList.add('is-visible');
          quickAddBtn.classList.add('hidden');
        }
      });

      if (!atcForm.dataset.inputInit) {
        atcForm.dataset.inputInit = 'true';
        atcForm.addEventListener('input', e => {
          const input = e.target;
          fetch(`${routes.cart_url}.json`)
            .then(res => res.json())
            .then(cartData => {
              const totalCartPrice = cartData.total_price / 100;
              const selectedPrice = parseFloat(input.dataset.price) / 100;

              if (totalCartPrice + selectedPrice > 250000) {
                window.showAlert('You cannot exceed PKR 250,000');
                return;
              }

              const itemInCart = cartData.items.find(item => item.variant_id === parseFloat(input.value));
              if (itemInCart && itemInCart.quantity >= 3) {
                window.showAlert('Max 3 items per size allowed');
                return;
              }

              atcFormApi(atcForm);
              atcForm.reset();

              if (mediaContainer) mediaContainer.innerHTML = '';
              quickCartContainer.querySelector('.bt-qatc-container')?.classList.remove('is-visible');
              quickCartContainer.querySelector('.bt-qatc-form-container')?.classList.remove('is-visible');
              quickAddBtn.classList.remove('hidden');
            });
        });
      }
    });
  }

  document.querySelectorAll('[id^="collection-"]').forEach(section => {
    const sectionId = section.id.replace('collection-', '');
    initQuickAddForSection(sectionId);
  });

  async function atcFormApi(form) {
    try {
      const cartSections = document.querySelector('cart-notification, cart-drawer');
      const formData = new FormData(form);

      if (cartSections) {
        formData.append('sections', Array.from(cartSections.getSectionsToRender(), s => s.id));
      }
      formData.append('sections_url', window.location.pathname);

      const resp = await fetch('/cart/add.js', { method: 'POST', body: formData });
      if (!resp.ok) throw new Error("Add to cart failed");
      const data = await resp.json();
      if (cartSections) cartSections.renderContents(data);
    } catch (err) {
      console.error(err);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-navigation-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

  const tabButtons = document.querySelectorAll('.tabs button');
  const tabContents = document.querySelectorAll('.tab-content');

  function initSlider(slider) {
    if (!slider) return;

    // Call slider library update if available
    if (typeof slider.update === 'function') slider.update();

    // Setup autoplay
    if (slider.dataset.autoplay === 'true') {
      const speed = parseInt(slider.dataset.speed) || 6000;
      const nextBtn = slider.querySelector('.slider-button--next');
      if (!nextBtn) return;

      clearInterval(slider.autoplay);
      slider.autoplay = setInterval(() => nextBtn.click(), speed);

      slider.addEventListener('mouseenter', () => clearInterval(slider.autoplay));
      slider.addEventListener('mouseleave', () => {
        slider.autoplay = setInterval(() => nextBtn.click(), speed);
      });
    }
  }

  // Initialize sliders in active tabs on page load
  document.querySelectorAll('.tab-content.active slider-component').forEach(slider => {
    initSlider(slider);
  });

  // Switch tabs
  tabButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      const tabId = this.dataset.tabId;

      // Remove active classes
      tabButtons.forEach(b => b.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));

      // Add active to clicked tab
      this.classList.add('active');
      const activeTab = document.getElementById(tabId);
      activeTab.classList.add('active');

      // Re-initialize slider in active tab
      const slider = activeTab.querySelector('slider-component');
      initSlider(slider);
    });
  });


  function initQuickAddForSection(sectionId) {
    const section = document.getElementById(`collection-${sectionId}`);
    if (!section) return;

    section.querySelectorAll('.card-wrapper-box').forEach(quickCartContainer => {
      if (quickCartContainer.dataset.qatcInit === 'true') return;
      quickCartContainer.dataset.qatcInit = 'true';

      const quickAddBtn = quickCartContainer.querySelector('.ethnc-qatc-btn-container');
      const atcForm = quickCartContainer.querySelector('.bt-qatc-form');
      const mediaContainer = quickCartContainer.querySelector('.ethnc-form-media');
      if (!quickAddBtn || !atcForm) return;

      quickAddBtn.addEventListener('click', () => {
        const onlyChildInput = quickCartContainer.querySelector('.bt-qatc-form-variant-input[data-only-child]');
        if (onlyChildInput) {
          fetch(`${routes.cart_url}.json`)
            .then(res => res.json())
            .then(cartData => {
              const totalCartPrice = cartData.total_price / 100;
              const selectedPrice = parseFloat(onlyChildInput.dataset.price) / 100;

              if (totalCartPrice + selectedPrice > 250000) {
                window.showAlert('You cannot exceed PKR 250,000');
                return;
              }

              const itemInCart = cartData.items.find(item => item.variant_id === parseFloat(onlyChildInput.value));
              if (itemInCart && itemInCart.quantity >= 3) {
                window.showAlert('Max 3 items per size allowed');
                return;
              }

              atcFormApi(atcForm);
              atcForm.reset();
            });
        } else {
          quickCartContainer.querySelector('.bt-qatc-container')?.classList.add('is-visible');
          quickCartContainer.querySelector('.bt-qatc-form-container')?.classList.add('is-visible');
          quickAddBtn.classList.add('hidden');
        }
      });

      if (!atcForm.dataset.inputInit) {
        atcForm.dataset.inputInit = 'true';
        atcForm.addEventListener('input', e => {
          const input = e.target;
          fetch(`${routes.cart_url}.json`)
            .then(res => res.json())
            .then(cartData => {
              const totalCartPrice = cartData.total_price / 100;
              const selectedPrice = parseFloat(input.dataset.price) / 100;

              if (totalCartPrice + selectedPrice > 250000) {
                window.showAlert('You cannot exceed PKR 250,000');
                return;
              }

              const itemInCart = cartData.items.find(item => item.variant_id === parseFloat(input.value));
              if (itemInCart && itemInCart.quantity >= 3) {
                window.showAlert('Max 3 items per size allowed');
                return;
              }

              atcFormApi(atcForm);
              atcForm.reset();

              if (mediaContainer) mediaContainer.innerHTML = '';
              quickCartContainer.querySelector('.bt-qatc-container')?.classList.remove('is-visible');
              quickCartContainer.querySelector('.bt-qatc-form-container')?.classList.remove('is-visible');
              quickAddBtn.classList.remove('hidden');
            });
        });
      }
    });
  }

  document.querySelectorAll('[id^="collection-"]').forEach(section => {
    const sectionId = section.id.replace('collection-', '');
    initQuickAddForSection(sectionId);
  });

  async function atcFormApi(form) {
    try {
      const cartSections = document.querySelector('cart-notification, cart-drawer');
      const formData = new FormData(form);

      if (cartSections) {
        formData.append('sections', Array.from(cartSections.getSectionsToRender(), s => s.id));
      }
      formData.append('sections_url', window.location.pathname);

      const resp = await fetch('/cart/add.js', { method: 'POST', body: formData });
      if (!resp.ok) throw new Error("Add to cart failed");
      const data = await resp.json();
      if (cartSections) cartSections.renderContents(data);
    } catch (err) {
      console.error(err);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-featured-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('slider-component[data-autoplay="true"]').forEach((slider) => {
    const speed = parseInt(slider.dataset.speed) || 6000;
    const nextBtn = slider.querySelector('.slider-button--next');
    if (!nextBtn) return;

    let autoplay = setInterval(() => {
      nextBtn.click();
    }, speed);

    // Pause autoplay on hover (optional)
    slider.addEventListener('mouseenter', () => clearInterval(autoplay));
    slider.addEventListener('mouseleave', () => {
      autoplay = setInterval(() => nextBtn.click(), speed);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shahnamen-banner-featured-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('slider-component[data-autoplay="true"]').forEach((slider) => {
    const speed = parseInt(slider.dataset.speed) || 6000;
    const nextBtn = slider.querySelector('.slider-button--next');
    if (!nextBtn) return;

    let autoplay = setInterval(() => {
      nextBtn.click();
    }, speed);

    // Pause autoplay on hover (optional)
    slider.addEventListener('mouseenter', () => clearInterval(autoplay));
    slider.addEventListener('mouseleave', () => {
      autoplay = setInterval(() => nextBtn.click(), speed);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
